import * as HttpService from './HttpService'

let namespace = 'enterprise/main-projects'

let all = (params, cb, errorCb) => {
    HttpService.get(namespace, params, cb, errorCb)
}

let projectTypes = (params, cb, errorCb) => {
    HttpService.get(namespace + '/types', params, cb, errorCb)
}

let main = (params, cb, errorCb) => {
    HttpService.get(namespace + '/list', params, cb, errorCb)
}

let employees = (params, cb, errorCb) => {
    HttpService.get('enterprise/employees', params, cb, errorCb)
}

let subProjectTypes = (params, cb, errorCb) => {
    HttpService.get('enterprise/sub-project-types', params, cb, errorCb)
}

export {
    all,
    projectTypes,
    main,
    employees,
    subProjectTypes
}



// WEBPACK FOOTER //
// ./src/services/mainProjectService.js